/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Modal_Title2Inputs */

const en_coinvestments_canceldeal_modal_title2 = /** @type {(inputs: Coinvestments_Canceldeal_Modal_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Deal`)
};

/**
* | output |
* | --- |
* | "Cancel Deal" |
*
* @param {Coinvestments_Canceldeal_Modal_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_modal_title2 = /** @type {((inputs?: Coinvestments_Canceldeal_Modal_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Modal_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_modal_title2(inputs)
});
export { coinvestments_canceldeal_modal_title2 as "coInvestments_cancelDeal_modal_title" }